import styled from "@emotion/styled";
import { Container } from "@mui/material";
import React from "react";
import { P} from "../../../Styles/style";
const Backround = styled.div`
background-color: #000;
padding:3px 0;=
`;
const Index = () => {
  return (
    <div>
      <Backround>
        <Container maxWidth="xl">
          <P color="#fff" align="center" data-aos="fade-zoom-in"
                data-aos-easing="ease-in"
                data-aos-delay="600"
                data-aos-offset="0"
                data-aos-duration="500">© 2023 by PEHPEH. All rights reserved!</P>
        </Container>
      </Backround>
    </div>
  );
};

export default Index;
